import type { FileBrowserActivitySnapshot } from './activity-types.js';

let inFlightRequests = 0;
let inFlightReads = 0;
/** Browse list/request activity only — not updated for reads (avoids extending browse cooldown). */
let lastBrowseRequestActivityAt = 0;

/** Worker mirror updated from the main thread over postMessage. */
let workerMirror: FileBrowserActivitySnapshot = {
  inFlightRequests: 0,
  inFlightReads: 0,
  lastActivityAt: 0,
};

export function touchBrowseRequestActivity(): void {
  lastBrowseRequestActivityAt = Date.now();
}

export function snapshotFromMain(): FileBrowserActivitySnapshot {
  return {
    inFlightRequests,
    inFlightReads,
    lastActivityAt: lastBrowseRequestActivityAt,
  };
}

export function getWorkerMirror(): FileBrowserActivitySnapshot {
  return workerMirror;
}

export function setWorkerMirror(snapshot: FileBrowserActivitySnapshot): void {
  workerMirror = snapshot;
}

export function incrementInFlightRequests(): void {
  inFlightRequests += 1;
  touchBrowseRequestActivity();
}

export function decrementInFlightRequests(): void {
  inFlightRequests = Math.max(0, inFlightRequests - 1);
  touchBrowseRequestActivity();
}

export function incrementInFlightReads(): void {
  inFlightReads += 1;
}

export function decrementInFlightReads(): void {
  inFlightReads = Math.max(0, inFlightReads - 1);
}
